import AccountCircleIcon from "@mui/icons-material/AccountCircle";

const AccountCircle = (props: any) => {
  return <AccountCircleIcon {...props} />;
};

export default AccountCircle;
